/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../electronicmail/service';
import '../client/client_action';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "messageservice": {
        "nested": {
          "service": {
            "nested": {
              "Locale": {
                "values": {
                  "DEFAULT_DO_NOT_USE": 0,
                  "EN_US": 1,
                  "ES_US": 2,
                  "EN_CA": 3,
                  "FR_CA": 4,
                  "JA_JP": 5,
                  "EN_GB": 6,
                  "EN_AU": 7,
                  "EN_JP": 8,
                  "FR_FR": 9,
                  "ES_ES": 10,
                  "EN_IE": 11,
                  "CA_ES": 12,
                  "PT_PT": 13,
                  "EN_ES": 14,
                  "EN_FR": 15
                }
              },
              "Action": {
                "values": {
                  "DO_NOT_USE_ACTION": 0,
                  "VIEW": 1,
                  "CLICK": 2,
                  "DISMISS": 3,
                  "SENT": 4,
                  "OPEN": 5,
                  "BOUNCE": 6,
                  "DROPPED": 7,
                  "DELIVERED": 8,
                  "COMPLAINT": 9
                }
              },
              "MessageTemplateSource": {
                "values": {
                  "TEMPLATE_MANAGER": 0,
                  "RISK_CONTENTFUL": 1
                }
              },
              "EntityType": {
                "values": {
                  "DO_NOT_USE_ENTITY_TYPE": 0,
                  "EMPLOYEE": 1,
                  "MERCHANT": 2,
                  "UNIT": 3,
                  "EMAIL_RECIPIENT": 4,
                  "SMS_PHONE_NUMBER": 5
                }
              },
              "MessageClass": {
                "values": {
                  "DO_NOT_USE_MESSAGE_CLASS": 0,
                  "BUSINESS_CRITICAL": 5,
                  "ALERT_SETUP_POS": 6,
                  "ALERT_COMPLETE_ORDERS": 8,
                  "NON_URGENT_BUSINESS_NOTICES_FOR_SELLERS": 10,
                  "MARKETING_TO_YOUR_EXISTING_CUSTOMERS": 11,
                  "MARKETING_TO_CUSTOMERS_YOU_WANT_TO_ACQUIRE": 12,
                  "SPONSORED": 13,
                  "ALERT_HIGH_PRIORITY": 14,
                  "ALERT_RESOLVE_DISPUTE": 15,
                  "ALERT_SUPPORT_CENTER": 16,
                  "ALERT_CUSTOMER_COMMS": 17
                }
              },
              "State": {
                "values": {
                  "UNREAD": 0,
                  "READ": 1,
                  "DISMISSED": 2
                }
              },
              "MessageStateChange": {
                "values": {
                  "DO_NOT_USE_MESSAGE_STATE_CHANGE": 0,
                  "NO_MESSAGE_STATE_CHANGE": 1,
                  "READ_STATE_CHANGE": 2
                }
              },
              "Theme": {
                "values": {
                  "LIGHT": 0,
                  "DARK": 1,
                  "DARK_GREEN": 2,
                  "RACER_YELLOW": 3,
                  "SKY_BLUE": 4
                }
              },
              "Entity": {
                "fields": {
                  "type": {
                    "type": "squareup.messageservice.service.EntityType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "MessageIds": {
                "fields": {
                  "messageIds": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "MessageUnit": {
                "fields": {
                  "requestToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "messageFormatId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "state": {
                    "type": "squareup.messageservice.service.State",
                    "id": 3,
                    "rule": "optional"
                  },
                  "messageUnitToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "messageClass": {
                    "type": "squareup.messageservice.service.MessageClass",
                    "id": 5,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "uint64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "messageId": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "defaultFormat": {
                    "type": "squareup.messageservice.service.DefaultFormat",
                    "id": 7
                  },
                  "notificationMessageFormat": {
                    "type": "squareup.messageservice.service.NotificationMessageFormat",
                    "id": 8
                  },
                  "warningNotificationFormat": {
                    "type": "squareup.messageservice.service.WarningNotificationFormat",
                    "id": 10
                  },
                  "iconNotificationFormat": {
                    "type": "squareup.messageservice.service.IconNotificationFormat",
                    "id": 11
                  },
                  "modalFormat": {
                    "type": "squareup.messageservice.service.ModalFormat",
                    "id": 12
                  },
                  "dialogFormat": {
                    "type": "squareup.messageservice.service.DialogFormat",
                    "id": 13
                  },
                  "tileFormat": {
                    "type": "squareup.messageservice.service.TileFormat",
                    "id": 14
                  },
                  "sposTileFormat": {
                    "type": "squareup.messageservice.service.SPOSTileFormat",
                    "id": 15
                  },
                  "actionFormat": {
                    "type": "squareup.messageservice.service.ActionFormat",
                    "id": 16
                  },
                  "globalBannerFormat": {
                    "type": "squareup.messageservice.service.GlobalBannerFormat",
                    "id": 17
                  },
                  "bannerV2Format": {
                    "type": "squareup.messageservice.service.BannerV2Format",
                    "id": 18
                  },
                  "releaseTileFormat": {
                    "type": "squareup.messageservice.service.ReleaseTileFormat",
                    "id": 19
                  },
                  "cardFeedPostFormat": {
                    "type": "squareup.messageservice.service.CardFeedPostFormat",
                    "id": 20
                  }
                },
                "nested": {
                  "content": {
                    "oneof": ["defaultFormat", "notificationMessageFormat", "warningNotificationFormat", "iconNotificationFormat", "modalFormat", "dialogFormat", "tileFormat", "sposTileFormat", "actionFormat", "globalBannerFormat", "bannerV2Format", "releaseTileFormat", "cardFeedPostFormat"]
                  }
                }
              },
              "MessageVariable": {
                "fields": {
                  "key": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "value": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Channel": {
                "values": {
                  "DO_NOT_USE": 0,
                  "IN_APP": 1,
                  "EMAIL": 2,
                  "SMS": 3,
                  "PUSH": 4
                }
              },
              "CreateMessageUnitRequest": {
                "fields": {
                  "entityToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "entityType": {
                    "type": "squareup.messageservice.service.EntityType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "expiration": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "messageId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "messageVariable": {
                    "type": "squareup.messageservice.service.MessageVariable",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "locale": {
                    "type": "squareup.messageservice.service.Locale",
                    "id": 7,
                    "rule": "optional"
                  },
                  "channel": {
                    "type": "squareup.messageservice.service.Channel",
                    "id": 8,
                    "rule": "optional"
                  },
                  "deepLinkToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "shouldTieLocale": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "campaignId": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "attachment": {
                    "type": "squareup.electronicmail.Attachment",
                    "id": 12,
                    "rule": "repeated"
                  },
                  "proxyApp": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "messageSource": {
                    "type": "squareup.messageservice.service.MessageTemplateSource",
                    "id": 15,
                    "rule": "optional",
                    "options": {
                      "default": "TEMPLATE_MANAGER"
                    }
                  }
                }
              },
              "CreateMessageUnitResponse": {
                "fields": {
                  "messageUnitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "BulkCreateMessageUnitRequest": {
                "fields": {
                  "requests": {
                    "type": "squareup.messageservice.service.CreateMessageUnitRequest",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "BulkCreateMessageUnitResponse": {
                "fields": {
                  "responses": {
                    "type": "squareup.messageservice.service.BulkCreateMessageUnitResponse.CreateMessageUnitResponseWithError",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "CreateMessageUnitResponseWithError": {
                    "fields": {
                      "createMessageUnitResponse": {
                        "type": "squareup.messageservice.service.CreateMessageUnitResponse",
                        "id": 1
                      },
                      "error": {
                        "type": "string",
                        "id": 2
                      }
                    },
                    "nested": {
                      "response": {
                        "oneof": ["createMessageUnitResponse", "error"]
                      }
                    }
                  }
                }
              },
              "BulkGetMessageUnitsInternalRequest": {
                "fields": {
                  "requests": {
                    "type": "squareup.messageservice.service.GetMessageUnitsInternalRequest",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetMessageUnitsInternalRequest": {
                "fields": {
                  "placementId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": 1
                    }
                  },
                  "locale": {
                    "type": "squareup.messageservice.service.Locale",
                    "id": 3,
                    "rule": "optional"
                  },
                  "offset": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": 0
                    }
                  },
                  "userAgent": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "employeeToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "ownedUnitTokens": {
                    "type": "string",
                    "id": 9,
                    "rule": "repeated"
                  }
                }
              },
              "GetMessageUnitsRequest": {
                "fields": {
                  "placementId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": 1
                    }
                  },
                  "locale": {
                    "type": "squareup.messageservice.service.Locale",
                    "id": 3,
                    "rule": "optional"
                  },
                  "offset": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": 0
                    }
                  },
                  "entity": {
                    "type": "squareup.messageservice.service.Entity",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "GetMessageUnitsResponse": {
                "fields": {
                  "messageUnits": {
                    "type": "squareup.messageservice.service.MessageUnit",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "BulkGetMessageUnitsRequest": {
                "fields": {
                  "requests": {
                    "type": "squareup.messageservice.service.GetMessageUnitsRequest",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "BulkGetMessageUnitsResponse": {
                "fields": {
                  "responses": {
                    "type": "squareup.messageservice.service.GetMessageUnitsResponse",
                    "id": 1,
                    "keyType": "string"
                  }
                }
              },
              "GetMessageUnitCountRequest": {
                "fields": {
                  "placementId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": 9999
                    }
                  },
                  "locale": {
                    "type": "squareup.messageservice.service.Locale",
                    "id": 3,
                    "rule": "optional"
                  },
                  "offset": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": 0
                    }
                  },
                  "messageState": {
                    "type": "squareup.messageservice.service.State",
                    "id": 5,
                    "rule": "optional",
                    "options": {
                      "default": "UNREAD"
                    }
                  }
                }
              },
              "GetMessageUnitCountResponse": {
                "fields": {
                  "count": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "TrackEngagementRequest": {
                "fields": {
                  "action": {
                    "type": "squareup.messageservice.service.Action",
                    "id": 3,
                    "rule": "optional"
                  },
                  "clickUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "entity": {
                    "type": "squareup.messageservice.service.Entity",
                    "id": 5,
                    "rule": "optional"
                  },
                  "changeMessageState": {
                    "type": "squareup.messageservice.service.MessageStateChange",
                    "id": 7,
                    "rule": "optional"
                  },
                  "userAgent": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "requestToken": {
                    "type": "string",
                    "id": 1
                  },
                  "messageId": {
                    "type": "string",
                    "id": 2
                  },
                  "messageUnitToken": {
                    "type": "string",
                    "id": 6
                  },
                  "messageIds": {
                    "type": "squareup.messageservice.service.MessageIds",
                    "id": 9
                  }
                },
                "nested": {
                  "identifier": {
                    "oneof": ["requestToken", "messageId", "messageUnitToken", "messageIds"]
                  }
                }
              },
              "TrackEngagementResponse": {
                "fields": {}
              },
              "BulkTrackEngagementRequest": {
                "fields": {
                  "requestToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "action": {
                    "type": "squareup.messageservice.service.Action",
                    "id": 2,
                    "rule": "optional"
                  },
                  "changeMessageState": {
                    "type": "squareup.messageservice.service.MessageStateChange",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "RecipientToEntityDumpRequest": {
                "fields": {}
              },
              "RecipientToEntityDumpResponse": {
                "fields": {}
              },
              "NotifyDevicesRequest": {
                "fields": {
                  "entity": {
                    "type": "squareup.messageservice.service.Entity",
                    "id": 1,
                    "rule": "optional"
                  },
                  "placementIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "NotifyDevicesResponse": {
                "fields": {}
              },
              "SendSmsRequest": {
                "fields": {
                  "phoneNumber": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "body": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "messageId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "appName": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "campaignId": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "proxyApp": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "entity": {
                    "type": "squareup.messageservice.service.Entity",
                    "id": 12,
                    "rule": "optional"
                  }
                }
              },
              "SendSmsResponse": {
                "fields": {}
              },
              "DefaultFormat": {
                "fields": {
                  "body": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "IconNotificationFormat": {
                "fields": {
                  "title": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "body": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "url": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "browserDialogBody": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "clientAction": {
                    "type": "squareup.client.ClientAction",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "WarningNotificationFormat": {
                "fields": {
                  "title": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "body": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "primaryCta": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "url": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "clientAction": {
                    "type": "squareup.client.ClientAction",
                    "id": 5,
                    "rule": "optional"
                  },
                  "browserDialogBody": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "aggregatable": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "aggregatedTitle": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "aggregatedBody": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "aggregatedPrimaryCta": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "aggregatedUrl": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "aggregatedClientAction": {
                    "type": "squareup.client.ClientAction",
                    "id": 12,
                    "rule": "optional"
                  },
                  "aggregatedBrowserDialogBody": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "browserDialogTitle": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "aggregatedBrowserDialogTitle": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  }
                }
              },
              "NotificationMessageFormat": {
                "fields": {
                  "title": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "body": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "primaryCta": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "url": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "clientAction": {
                    "type": "squareup.client.ClientAction",
                    "id": 5,
                    "rule": "optional"
                  },
                  "browserDialogBody": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "aggregatable": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "aggregatedTitle": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "aggregatedBody": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "aggregatedPrimaryCta": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "aggregatedUrl": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "aggregatedClientAction": {
                    "type": "squareup.client.ClientAction",
                    "id": 12,
                    "rule": "optional"
                  },
                  "aggregatedBrowserDialogBody": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "visualStyle": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "showTooltip": {
                    "type": "bool",
                    "id": 15,
                    "rule": "optional"
                  },
                  "tooltipContent": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "tooltipText": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "icon": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "clientUrl": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  },
                  "browserDialogTitle": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "aggregatedBrowserDialogTitle": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  }
                }
              },
              "ModalFormat": {
                "fields": {
                  "slides": {
                    "type": "squareup.messageservice.service.ModalFormat.ModalSlide",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "primaryCtaColor": {
                    "type": "squareup.messageservice.service.ModalFormat.Gradient",
                    "id": 2,
                    "rule": "optional"
                  },
                  "secondaryCtaColor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ModalSlide": {
                    "fields": {
                      "phoneTitle": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "phoneBody": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "tabletTitle": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "tabletBody": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "phoneImageUrl": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "tabletImageUrl": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "dismissible": {
                        "type": "bool",
                        "id": 7,
                        "rule": "optional"
                      },
                      "ctaNext": {
                        "type": "squareup.messageservice.service.ModalFormat.ModalSlide.CtaNext",
                        "id": 8
                      },
                      "ctaDeepLink": {
                        "type": "squareup.messageservice.service.ModalFormat.ModalSlide.CtaDeepLink",
                        "id": 9
                      },
                      "ctaExternalUrl": {
                        "type": "squareup.messageservice.service.ModalFormat.ModalSlide.CtaExternalUrl",
                        "id": 10
                      },
                      "ctaDeepLinkSpos": {
                        "type": "squareup.messageservice.service.ModalFormat.ModalSlide.CtaClientAction",
                        "id": 11
                      },
                      "ctaExternalUrlSpos": {
                        "type": "squareup.messageservice.service.ModalFormat.ModalSlide.CtaExternalUrl",
                        "id": 12
                      }
                    },
                    "nested": {
                      "CtaNext": {
                        "fields": {
                          "ctaText": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "CtaDeepLink": {
                        "fields": {
                          "ctaText": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ctaLink": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CtaExternalUrl": {
                        "fields": {
                          "ctaText": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ctaLink": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "CtaClientAction": {
                        "fields": {
                          "ctaText": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "clientAction": {
                            "type": "squareup.client.ClientAction",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "primary_cta": {
                        "oneof": ["ctaNext", "ctaDeepLink", "ctaExternalUrl"]
                      },
                      "primary_cta_spos": {
                        "oneof": ["ctaDeepLinkSpos", "ctaExternalUrlSpos"]
                      }
                    }
                  },
                  "Gradient": {
                    "fields": {
                      "start": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "end": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "TileFormat": {
                "fields": {
                  "title": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "body": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "linkText": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "linkUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "themeColor": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional",
                    "options": {
                      "default": "white"
                    }
                  },
                  "showNew": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "SPOSTileFormat": {
                "fields": {
                  "title": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "body": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "linkText": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "linkUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "imageUrl": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "clientAction": {
                    "type": "squareup.client.ClientAction",
                    "id": 6,
                    "rule": "optional"
                  },
                  "dismissible": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "themeColor": {
                    "type": "squareup.messageservice.service.Theme",
                    "id": 8,
                    "rule": "required"
                  }
                }
              },
              "ActionFormat": {
                "fields": {
                  "title": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "body": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "icon": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "aggregatable": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "aggregatedTitle": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "aggregatedBody": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "linkUrl": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "clientUrl": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "messagePriority": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "dueDate": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "aggregatedLinkUrl": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "aggregatedClientUrl": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "dismissible": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  },
                  "ctaText": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "aggregatedCtaText": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  }
                }
              },
              "DialogFormat": {
                "fields": {
                  "phoneTitle": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "tabletTitle": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "phoneBody": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "tabletBody": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "phoneCtaText": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "tabletCtaText": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "phoneDismissText": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "tabletDismissText": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "phoneImageUrl": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "tabletImageUrl": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "phoneCtaUrl": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "tabletCtaUrl": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  }
                }
              },
              "GlobalBannerFormat": {
                "fields": {
                  "type": {
                    "type": "squareup.messageservice.service.GlobalBannerFormat.GlobalBannerType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "body": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "ctaType": {
                    "type": "squareup.messageservice.service.GlobalBannerFormat.GlobalBannerCtaType",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": "GLOBAL_BANNER_CTA_TYPE_NO_CTA"
                    }
                  },
                  "ctaText": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "webUrl": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "appUrl": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "dismissible": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "modalTitle": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "modalBody": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "modalButtonText": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "modalButtonUrl": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "modalImage": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "GlobalBannerType": {
                    "values": {
                      "DO_NOT_USE_GLOBAL_BANNER_TYPE": 0,
                      "GLOBAL_BANNER_TYPE_SUCCESS": 1,
                      "GLOBAL_BANNER_TYPE_INFO": 2,
                      "GLOBAL_BANNER_TYPE_WARNING": 3,
                      "GLOBAL_BANNER_TYPE_CRITICAL": 4
                    }
                  },
                  "GlobalBannerCtaType": {
                    "values": {
                      "DO_NOT_USE_GLOBAL_BANNER_CTA_TYPE": 0,
                      "GLOBAL_BANNER_CTA_TYPE_NO_CTA": 1,
                      "GLOBAL_BANNER_CTA_TYPE_URL": 2,
                      "GLOBAL_BANNER_CTA_TYPE_MODAL": 3
                    }
                  }
                }
              },
              "BannerV2Format": {
                "fields": {
                  "type": {
                    "type": "squareup.messageservice.service.BannerV2Format.BannerV2Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "title": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "body": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "primaryLinkText": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "primaryLinkWebUrl": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "primaryLinkAppUrl": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "secondaryLinkText": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "secondaryLinkWebUrl": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "secondaryLinkAppUrl": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "dismissible": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  }
                },
                "nested": {
                  "BannerV2Type": {
                    "values": {
                      "DO_NOT_USE_BANNER_V2_TYPE": 0,
                      "BANNER_V2_TYPE_SUCCESS": 1,
                      "BANNER_V2_TYPE_INFO": 2,
                      "BANNER_V2_TYPE_WARNING": 3,
                      "BANNER_V2_TYPE_CRITICAL": 4
                    }
                  }
                }
              },
              "ReleaseTileFormat": {
                "fields": {
                  "title": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "mediaUrl": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "releaseDate": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "primaryTag": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "secondaryTag": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "ctaType": {
                    "type": "squareup.messageservice.service.ReleaseTileFormat.ReleaseTileCtaType",
                    "id": 7,
                    "rule": "optional"
                  },
                  "modalTitle": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "modalBody": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "modalMediaUrl": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ReleaseTileCtaType": {
                    "values": {
                      "DO_NOT_USE_RELEASE_TILE_CTA_TYPE": 0,
                      "RELEASE_TILE_CTA_TYPE_MODAL": 1
                    }
                  }
                }
              },
              "CardFeedPostCategory": {
                "values": {
                  "BETA": 1,
                  "IMPROVEMENT": 2,
                  "FEATURE": 3,
                  "NEW": 4
                }
              },
              "CardFeedPostContentNodeType": {
                "values": {
                  "HEADING": 1,
                  "PARAGRAPH": 2,
                  "IMAGE": 3,
                  "BUTTON": 4
                }
              },
              "CardFeedPostContentHeadingFields": {
                "fields": {
                  "text": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CardFeedPostContentParagraphFields": {
                "fields": {
                  "text": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CardFeedPostContentImageFields": {
                "fields": {
                  "desktopUrl": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "desktopAltText": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "mobileUrl": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "mobileAltText": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "CardFeedPostContentButtonFields": {
                "fields": {
                  "text": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "url": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CardFeedPostContentNode": {
                "fields": {
                  "type": {
                    "type": "squareup.messageservice.service.CardFeedPostContentNodeType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "headingFields": {
                    "type": "squareup.messageservice.service.CardFeedPostContentHeadingFields",
                    "id": 2
                  },
                  "paragraphFields": {
                    "type": "squareup.messageservice.service.CardFeedPostContentParagraphFields",
                    "id": 3
                  },
                  "imageFields": {
                    "type": "squareup.messageservice.service.CardFeedPostContentImageFields",
                    "id": 4
                  },
                  "buttonFields": {
                    "type": "squareup.messageservice.service.CardFeedPostContentButtonFields",
                    "id": 5
                  }
                },
                "nested": {
                  "content": {
                    "oneof": ["headingFields", "paragraphFields", "imageFields", "buttonFields"]
                  }
                }
              },
              "CardFeedPostFormat": {
                "fields": {
                  "title": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "body": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "category": {
                    "type": "squareup.messageservice.service.CardFeedPostCategory",
                    "id": 3,
                    "rule": "optional"
                  },
                  "products": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "imageUrl": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "imageAltText": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "releaseDate": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "longFormContent": {
                    "type": "squareup.messageservice.service.CardFeedPostContentNode",
                    "id": 8,
                    "rule": "repeated"
                  }
                }
              },
              "MessageTemplate": {
                "fields": {
                  "approvalStatus": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "campaignIds": {
                    "type": "int64",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "channel": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "content": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "contentVersion": {
                    "type": "int32",
                    "id": 5,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "dri": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "frequencyCap": {
                    "type": "int32",
                    "id": 8,
                    "rule": "optional"
                  },
                  "messageBackendContentId": {
                    "type": "int64",
                    "id": 9,
                    "rule": "optional"
                  },
                  "messageClass": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "messageClassId": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "messageFormat": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "messageFormatId": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "messageName": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "metadata": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "placementIds": {
                    "type": "string",
                    "id": 16,
                    "rule": "repeated"
                  },
                  "placements": {
                    "type": "string",
                    "id": 17,
                    "rule": "repeated"
                  },
                  "sender": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  }
                }
              },
              "GetMessageTemplateRequest": {
                "fields": {
                  "messageTemplateId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetMessageTemplateResponse": {
                "fields": {
                  "template": {
                    "type": "squareup.messageservice.service.MessageTemplate",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UploadImageRequest": {
                "fields": {
                  "filename": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "contentType": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "image": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UploadImageResponse": {
                "fields": {
                  "url": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "MessageserviceService": {
                "methods": {
                  "BulkGetMessageUnitsInternal": {
                    "requestType": "squareup.messageservice.service.BulkGetMessageUnitsInternalRequest",
                    "responseType": "squareup.messageservice.service.BulkGetMessageUnitsResponse"
                  },
                  "BulkTrackEngagement": {
                    "requestType": "squareup.messageservice.service.BulkTrackEngagementRequest",
                    "responseType": "squareup.messageservice.service.TrackEngagementResponse"
                  },
                  "CreateMessageUnit": {
                    "requestType": "squareup.messageservice.service.CreateMessageUnitRequest",
                    "responseType": "squareup.messageservice.service.CreateMessageUnitResponse"
                  },
                  "BulkCreateMessageUnit": {
                    "requestType": "squareup.messageservice.service.BulkCreateMessageUnitRequest",
                    "responseType": "squareup.messageservice.service.BulkCreateMessageUnitResponse"
                  },
                  "BulkGetMessageUnits": {
                    "requestType": "squareup.messageservice.service.BulkGetMessageUnitsRequest",
                    "responseType": "squareup.messageservice.service.BulkGetMessageUnitsResponse"
                  },
                  "GetMessageUnits": {
                    "requestType": "squareup.messageservice.service.GetMessageUnitsRequest",
                    "responseType": "squareup.messageservice.service.GetMessageUnitsResponse"
                  },
                  "GetMessageUnitsInternal": {
                    "requestType": "squareup.messageservice.service.GetMessageUnitsInternalRequest",
                    "responseType": "squareup.messageservice.service.GetMessageUnitsResponse"
                  },
                  "NotifyDevices": {
                    "requestType": "squareup.messageservice.service.NotifyDevicesRequest",
                    "responseType": "squareup.messageservice.service.NotifyDevicesResponse"
                  },
                  "TrackEngagement": {
                    "requestType": "squareup.messageservice.service.TrackEngagementRequest",
                    "responseType": "squareup.messageservice.service.TrackEngagementResponse"
                  },
                  "TrackEngagementInternal": {
                    "requestType": "squareup.messageservice.service.TrackEngagementRequest",
                    "responseType": "squareup.messageservice.service.TrackEngagementResponse"
                  },
                  "RecipientToEntityDump": {
                    "requestType": "squareup.messageservice.service.RecipientToEntityDumpRequest",
                    "responseType": "squareup.messageservice.service.RecipientToEntityDumpResponse"
                  },
                  "SendSms": {
                    "requestType": "squareup.messageservice.service.SendSmsRequest",
                    "responseType": "squareup.messageservice.service.SendSmsResponse"
                  },
                  "GetMessageUnitCount": {
                    "requestType": "squareup.messageservice.service.GetMessageUnitCountRequest",
                    "responseType": "squareup.messageservice.service.GetMessageUnitCountResponse"
                  },
                  "GetMessageTemplate": {
                    "requestType": "squareup.messageservice.service.GetMessageTemplateRequest",
                    "responseType": "squareup.messageservice.service.GetMessageTemplateResponse"
                  },
                  "UploadImage": {
                    "requestType": "squareup.messageservice.service.UploadImageRequest",
                    "responseType": "squareup.messageservice.service.UploadImageResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.Locale && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.Action && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.MessageTemplateSource && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.EntityType && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.MessageClass && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.State && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.MessageStateChange && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.Theme && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.Entity && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.MessageIds && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.MessageUnit && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.MessageVariable && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.Channel && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.CreateMessageUnitRequest && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.CreateMessageUnitResponse && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.BulkCreateMessageUnitRequest && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.BulkCreateMessageUnitResponse && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.BulkCreateMessageUnitResponse?.nested?.CreateMessageUnitResponseWithError && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.BulkGetMessageUnitsInternalRequest && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.GetMessageUnitsInternalRequest && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.GetMessageUnitsRequest && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.GetMessageUnitsResponse && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.BulkGetMessageUnitsRequest && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.BulkGetMessageUnitsResponse && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.GetMessageUnitCountRequest && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.GetMessageUnitCountResponse && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.TrackEngagementRequest && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.TrackEngagementResponse && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.BulkTrackEngagementRequest && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.RecipientToEntityDumpRequest && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.RecipientToEntityDumpResponse && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.NotifyDevicesRequest && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.NotifyDevicesResponse && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.SendSmsRequest && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.SendSmsResponse && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.DefaultFormat && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.IconNotificationFormat && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.WarningNotificationFormat && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.NotificationMessageFormat && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.ModalFormat && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.ModalFormat?.nested?.ModalSlide && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.ModalFormat?.nested?.ModalSlide?.nested?.CtaNext && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.ModalFormat?.nested?.ModalSlide?.nested?.CtaDeepLink && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.ModalFormat?.nested?.ModalSlide?.nested?.CtaExternalUrl && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.ModalFormat?.nested?.ModalSlide?.nested?.CtaClientAction && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.ModalFormat?.nested?.Gradient && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.TileFormat && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.SPOSTileFormat && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.ActionFormat && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.DialogFormat && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.GlobalBannerFormat && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.GlobalBannerFormat?.nested?.GlobalBannerType && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.GlobalBannerFormat?.nested?.GlobalBannerCtaType && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.BannerV2Format && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.BannerV2Format?.nested?.BannerV2Type && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.ReleaseTileFormat && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.ReleaseTileFormat?.nested?.ReleaseTileCtaType && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.CardFeedPostCategory && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.CardFeedPostContentNodeType && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.CardFeedPostContentHeadingFields && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.CardFeedPostContentParagraphFields && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.CardFeedPostContentImageFields && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.CardFeedPostContentButtonFields && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.CardFeedPostContentNode && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.CardFeedPostFormat && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.MessageTemplate && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.GetMessageTemplateRequest && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.GetMessageTemplateResponse && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.UploadImageRequest && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.UploadImageResponse && !$root.nested?.squareup?.nested?.messageservice?.nested?.service?.nested?.MessageserviceService) {
  $root.addJSON(jsonData);
}

/**
 * Iterable locales
 *
 * SOURCE Locale @ squareup/messageservice/service.proto at 17:1
 */
export const Locale = $root.lookupEnum('squareup.messageservice.service.Locale').values;
/**
 * SOURCE Action @ squareup/messageservice/service.proto at 36:1
 */
export const Action = $root.lookupEnum('squareup.messageservice.service.Action').values;
/**
 * SOURCE MessageTemplateSource @ squareup/messageservice/service.proto at 49:1
 */
export const MessageTemplateSource = $root.lookupEnum('squareup.messageservice.service.MessageTemplateSource').values;
/**
 * SOURCE EntityType @ squareup/messageservice/service.proto at 54:1
 */
export const EntityType = $root.lookupEnum('squareup.messageservice.service.EntityType').values;
/**
 * SOURCE MessageClass @ squareup/messageservice/service.proto at 63:1
 */
export const MessageClass = $root.lookupEnum('squareup.messageservice.service.MessageClass').values;
/**
 * SOURCE State @ squareup/messageservice/service.proto at 81:1
 */
export const State = $root.lookupEnum('squareup.messageservice.service.State').values;
/**
 * Allows the definition of the intended change specification to enforce when mutating message state
 * throughout all message systems.
 * Supported message state change specifications
 *
 * SOURCE MessageStateChange @ squareup/messageservice/service.proto at 91:1
 */
export const MessageStateChange = $root.lookupEnum('squareup.messageservice.service.MessageStateChange').values;
/**
 * SOURCE Theme @ squareup/messageservice/service.proto at 97:1
 */
export const Theme = $root.lookupEnum('squareup.messageservice.service.Theme').values;
/**
 * SOURCE Entity @ squareup/messageservice/service.proto at 105:1
 */
export const Entity = $root.lookupType('squareup.messageservice.service.Entity');
fixType(Entity, {
  type: {
    required: true
  },
  token: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Entity);
/**
 * SOURCE MessageIds @ squareup/messageservice/service.proto at 113:1
 */
export const MessageIds = $root.lookupType('squareup.messageservice.service.MessageIds');
fixType(MessageIds);
Builder.createAndAttachToType(MessageIds);
/**
 * SOURCE MessageUnit @ squareup/messageservice/service.proto at 117:1
 */
export const MessageUnit = $root.lookupType('squareup.messageservice.service.MessageUnit');
fixType(MessageUnit);
Builder.createAndAttachToType(MessageUnit);
/**
 * This message duplicates the same message in NOM's service.proto due to circular dependencies.
 * It should be fixed once COMMSPLAT-632 is implemented
 * Variable in a Message to be rendered in this Message Unit
 *
 * SOURCE MessageVariable @ squareup/messageservice/service.proto at 154:1
 */
export const MessageVariable = $root.lookupType('squareup.messageservice.service.MessageVariable');
fixType(MessageVariable, {
  key: {
    notEmpty: true
  },
  value: {
    required: true
  }
});
Builder.createAndAttachToType(MessageVariable);
/**
 * This message duplicates the same message in NOM's service.proto due to circular dependencies.
 * It should be fixed once COMMSPLAT-632 is implemented
 *
 * SOURCE Channel @ squareup/messageservice/service.proto at 165:1
 */
export const Channel = $root.lookupEnum('squareup.messageservice.service.Channel').values;
/**
 * This message duplicates the same message in the NOMS service.proto due to circular dependencies.
 * It should be fixed once COMMSPLAT-632 is implemented
 * Request for a Message Unit to be created
 *
 * SOURCE CreateMessageUnitRequest @ squareup/messageservice/service.proto at 177:1
 */
export const CreateMessageUnitRequest = $root.lookupType('squareup.messageservice.service.CreateMessageUnitRequest');
fixType(CreateMessageUnitRequest, {
  entityToken: {
    notEmpty: true
  },
  entityType: {
    required: true
  },
  idempotenceKey: {
    notEmpty: true
  },
  messageId: {
    required: true
  }
});
Builder.createAndAttachToType(CreateMessageUnitRequest);
/**
 * This message duplicates the same message in NOM's service.proto due to circular dependencies.
 * It should be fixed once COMMSPLAT-632 is implemented
 * Response after a Message Unit is created
 *
 * SOURCE CreateMessageUnitResponse @ squareup/messageservice/service.proto at 228:1
 */
export const CreateMessageUnitResponse = $root.lookupType('squareup.messageservice.service.CreateMessageUnitResponse');
fixType(CreateMessageUnitResponse, {
  messageUnitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateMessageUnitResponse);
/**
 * SOURCE BulkCreateMessageUnitRequest @ squareup/messageservice/service.proto at 233:1
 */
export const BulkCreateMessageUnitRequest = $root.lookupType('squareup.messageservice.service.BulkCreateMessageUnitRequest');
fixType(BulkCreateMessageUnitRequest);
Builder.createAndAttachToType(BulkCreateMessageUnitRequest);
/**
 * SOURCE BulkCreateMessageUnitResponse @ squareup/messageservice/service.proto at 238:1
 */
export const BulkCreateMessageUnitResponse = $root.lookupType('squareup.messageservice.service.BulkCreateMessageUnitResponse');
fixType(BulkCreateMessageUnitResponse);
Builder.createAndAttachToType(BulkCreateMessageUnitResponse);
/**
 * SOURCE CreateMessageUnitResponseWithError @ squareup/messageservice/service.proto at 239:3
 */
BulkCreateMessageUnitResponse.CreateMessageUnitResponseWithError = $root.lookupType('squareup.messageservice.service.BulkCreateMessageUnitResponse.CreateMessageUnitResponseWithError');
fixType(BulkCreateMessageUnitResponse.CreateMessageUnitResponseWithError);
Builder.createAndAttachToType(BulkCreateMessageUnitResponse.CreateMessageUnitResponseWithError);
/**
 * SOURCE BulkGetMessageUnitsInternalRequest @ squareup/messageservice/service.proto at 251:1
 */
export const BulkGetMessageUnitsInternalRequest = $root.lookupType('squareup.messageservice.service.BulkGetMessageUnitsInternalRequest');
fixType(BulkGetMessageUnitsInternalRequest);
Builder.createAndAttachToType(BulkGetMessageUnitsInternalRequest);
/**
 * SOURCE GetMessageUnitsInternalRequest @ squareup/messageservice/service.proto at 256:1
 */
export const GetMessageUnitsInternalRequest = $root.lookupType('squareup.messageservice.service.GetMessageUnitsInternalRequest');
fixType(GetMessageUnitsInternalRequest);
Builder.createAndAttachToType(GetMessageUnitsInternalRequest);
/**
 * SOURCE GetMessageUnitsRequest @ squareup/messageservice/service.proto at 278:1
 */
export const GetMessageUnitsRequest = $root.lookupType('squareup.messageservice.service.GetMessageUnitsRequest');
fixType(GetMessageUnitsRequest);
Builder.createAndAttachToType(GetMessageUnitsRequest);
/**
 * SOURCE GetMessageUnitsResponse @ squareup/messageservice/service.proto at 292:1
 */
export const GetMessageUnitsResponse = $root.lookupType('squareup.messageservice.service.GetMessageUnitsResponse');
fixType(GetMessageUnitsResponse);
Builder.createAndAttachToType(GetMessageUnitsResponse);
/**
 * SOURCE BulkGetMessageUnitsRequest @ squareup/messageservice/service.proto at 297:1
 */
export const BulkGetMessageUnitsRequest = $root.lookupType('squareup.messageservice.service.BulkGetMessageUnitsRequest');
fixType(BulkGetMessageUnitsRequest);
Builder.createAndAttachToType(BulkGetMessageUnitsRequest);
/**
 * SOURCE BulkGetMessageUnitsResponse @ squareup/messageservice/service.proto at 301:1
 */
export const BulkGetMessageUnitsResponse = $root.lookupType('squareup.messageservice.service.BulkGetMessageUnitsResponse');
fixType(BulkGetMessageUnitsResponse);
Builder.createAndAttachToType(BulkGetMessageUnitsResponse);
/**
 * SOURCE GetMessageUnitCountRequest @ squareup/messageservice/service.proto at 306:1
 */
export const GetMessageUnitCountRequest = $root.lookupType('squareup.messageservice.service.GetMessageUnitCountRequest');
fixType(GetMessageUnitCountRequest);
Builder.createAndAttachToType(GetMessageUnitCountRequest);
/**
 * SOURCE GetMessageUnitCountResponse @ squareup/messageservice/service.proto at 320:1
 */
export const GetMessageUnitCountResponse = $root.lookupType('squareup.messageservice.service.GetMessageUnitCountResponse');
fixType(GetMessageUnitCountResponse);
Builder.createAndAttachToType(GetMessageUnitCountResponse);
/**
 * SOURCE TrackEngagementRequest @ squareup/messageservice/service.proto at 325:1
 */
export const TrackEngagementRequest = $root.lookupType('squareup.messageservice.service.TrackEngagementRequest');
fixType(TrackEngagementRequest, {
  action: {
    required: true
  }
});
Builder.createAndAttachToType(TrackEngagementRequest);
/**
 * SOURCE TrackEngagementResponse @ squareup/messageservice/service.proto at 348:1
 */
export const TrackEngagementResponse = $root.lookupType('squareup.messageservice.service.TrackEngagementResponse');
fixType(TrackEngagementResponse);
Builder.createAndAttachToType(TrackEngagementResponse);
/**
 * SOURCE BulkTrackEngagementRequest @ squareup/messageservice/service.proto at 351:1
 */
export const BulkTrackEngagementRequest = $root.lookupType('squareup.messageservice.service.BulkTrackEngagementRequest');
fixType(BulkTrackEngagementRequest, {
  action: {
    required: true
  }
});
Builder.createAndAttachToType(BulkTrackEngagementRequest);
/**
 * SOURCE RecipientToEntityDumpRequest @ squareup/messageservice/service.proto at 360:1
 */
export const RecipientToEntityDumpRequest = $root.lookupType('squareup.messageservice.service.RecipientToEntityDumpRequest');
fixType(RecipientToEntityDumpRequest);
Builder.createAndAttachToType(RecipientToEntityDumpRequest);
/**
 * SOURCE RecipientToEntityDumpResponse @ squareup/messageservice/service.proto at 363:1
 */
export const RecipientToEntityDumpResponse = $root.lookupType('squareup.messageservice.service.RecipientToEntityDumpResponse');
fixType(RecipientToEntityDumpResponse);
Builder.createAndAttachToType(RecipientToEntityDumpResponse);
/**
 * SOURCE NotifyDevicesRequest @ squareup/messageservice/service.proto at 366:1
 */
export const NotifyDevicesRequest = $root.lookupType('squareup.messageservice.service.NotifyDevicesRequest');
fixType(NotifyDevicesRequest, {
  entity: {
    required: true
  }
});
Builder.createAndAttachToType(NotifyDevicesRequest);
/**
 * SOURCE NotifyDevicesResponse @ squareup/messageservice/service.proto at 372:1
 */
export const NotifyDevicesResponse = $root.lookupType('squareup.messageservice.service.NotifyDevicesResponse');
fixType(NotifyDevicesResponse);
Builder.createAndAttachToType(NotifyDevicesResponse);
/**
 * SOURCE SendSmsRequest @ squareup/messageservice/service.proto at 375:1
 */
export const SendSmsRequest = $root.lookupType('squareup.messageservice.service.SendSmsRequest');
fixType(SendSmsRequest, {
  phoneNumber: {
    notEmpty: true
  },
  body: {
    notEmpty: true
  },
  idempotenceKey: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SendSmsRequest);
/**
 * SOURCE SendSmsResponse @ squareup/messageservice/service.proto at 397:1
 */
export const SendSmsResponse = $root.lookupType('squareup.messageservice.service.SendSmsResponse');
fixType(SendSmsResponse);
Builder.createAndAttachToType(SendSmsResponse);
/**
 * SOURCE DefaultFormat @ squareup/messageservice/service.proto at 400:1
 */
export const DefaultFormat = $root.lookupType('squareup.messageservice.service.DefaultFormat');
fixType(DefaultFormat);
Builder.createAndAttachToType(DefaultFormat);
/**
 * SOURCE IconNotificationFormat @ squareup/messageservice/service.proto at 482:1
 */
export const IconNotificationFormat = $root.lookupType('squareup.messageservice.service.IconNotificationFormat');
fixType(IconNotificationFormat, {
  title: {
    notEmpty: true
  },
  body: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(IconNotificationFormat);
/**
 * SOURCE WarningNotificationFormat @ squareup/messageservice/service.proto at 528:1
 */
export const WarningNotificationFormat = $root.lookupType('squareup.messageservice.service.WarningNotificationFormat');
fixType(WarningNotificationFormat, {
  title: {
    notEmpty: true
  },
  body: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(WarningNotificationFormat);
/**
 * SOURCE NotificationMessageFormat @ squareup/messageservice/service.proto at 654:1
 */
export const NotificationMessageFormat = $root.lookupType('squareup.messageservice.service.NotificationMessageFormat');
fixType(NotificationMessageFormat, {
  title: {
    notEmpty: true
  },
  body: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(NotificationMessageFormat);
/**
 * SOURCE ModalFormat @ squareup/messageservice/service.proto at 828:1
 */
export const ModalFormat = $root.lookupType('squareup.messageservice.service.ModalFormat');
fixType(ModalFormat, {
  primaryCtaColor: {
    required: true
  }
});
Builder.createAndAttachToType(ModalFormat);
/**
 * SOURCE ModalSlide @ squareup/messageservice/service.proto at 838:3
 */
ModalFormat.ModalSlide = $root.lookupType('squareup.messageservice.service.ModalFormat.ModalSlide');
fixType(ModalFormat.ModalSlide, {
  phoneTitle: {
    notEmpty: true
  },
  phoneBody: {
    notEmpty: true
  },
  tabletTitle: {
    notEmpty: true
  },
  tabletBody: {
    notEmpty: true
  },
  phoneImageUrl: {
    notEmpty: true
  },
  tabletImageUrl: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ModalFormat.ModalSlide);
/**
 * SOURCE CtaNext @ squareup/messageservice/service.proto at 873:5
 */
ModalFormat.ModalSlide.CtaNext = $root.lookupType('squareup.messageservice.service.ModalFormat.ModalSlide.CtaNext');
fixType(ModalFormat.ModalSlide.CtaNext, {
  ctaText: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ModalFormat.ModalSlide.CtaNext);
/**
 * Used for Appointments deep links
 *
 * SOURCE CtaDeepLink @ squareup/messageservice/service.proto at 878:5
 */
ModalFormat.ModalSlide.CtaDeepLink = $root.lookupType('squareup.messageservice.service.ModalFormat.ModalSlide.CtaDeepLink');
fixType(ModalFormat.ModalSlide.CtaDeepLink, {
  ctaText: {
    notEmpty: true
  },
  ctaLink: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ModalFormat.ModalSlide.CtaDeepLink);
/**
 * SOURCE CtaExternalUrl @ squareup/messageservice/service.proto at 883:5
 */
ModalFormat.ModalSlide.CtaExternalUrl = $root.lookupType('squareup.messageservice.service.ModalFormat.ModalSlide.CtaExternalUrl');
fixType(ModalFormat.ModalSlide.CtaExternalUrl, {
  ctaText: {
    notEmpty: true
  },
  ctaLink: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ModalFormat.ModalSlide.CtaExternalUrl);
/**
 * SOURCE CtaClientAction @ squareup/messageservice/service.proto at 888:5
 */
ModalFormat.ModalSlide.CtaClientAction = $root.lookupType('squareup.messageservice.service.ModalFormat.ModalSlide.CtaClientAction');
fixType(ModalFormat.ModalSlide.CtaClientAction, {
  ctaText: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ModalFormat.ModalSlide.CtaClientAction);
/**
 * SOURCE Gradient @ squareup/messageservice/service.proto at 901:3
 */
ModalFormat.Gradient = $root.lookupType('squareup.messageservice.service.ModalFormat.Gradient');
fixType(ModalFormat.Gradient, {
  start: {
    notEmpty: true
  },
  end: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ModalFormat.Gradient);
/**
 * SOURCE TileFormat @ squareup/messageservice/service.proto at 910:1
 */
export const TileFormat = $root.lookupType('squareup.messageservice.service.TileFormat');
fixType(TileFormat, {
  body: {
    notEmpty: true
  },
  linkText: {
    notEmpty: true
  },
  linkUrl: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TileFormat);
/**
 * SOURCE SPOSTileFormat @ squareup/messageservice/service.proto at 930:1
 */
export const SPOSTileFormat = $root.lookupType('squareup.messageservice.service.SPOSTileFormat');
fixType(SPOSTileFormat, {
  body: {
    notEmpty: true
  },
  linkText: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SPOSTileFormat);
/**
 * SOURCE ActionFormat @ squareup/messageservice/service.proto at 956:1
 */
export const ActionFormat = $root.lookupType('squareup.messageservice.service.ActionFormat');
fixType(ActionFormat, {
  title: {
    notEmpty: true
  },
  messagePriority: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ActionFormat);
/**
 * SOURCE DialogFormat @ squareup/messageservice/service.proto at 1003:1
 */
export const DialogFormat = $root.lookupType('squareup.messageservice.service.DialogFormat');
fixType(DialogFormat, {
  phoneTitle: {
    notEmpty: true
  },
  tabletTitle: {
    notEmpty: true
  },
  phoneBody: {
    notEmpty: true
  },
  tabletBody: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DialogFormat);
/**
 * SOURCE GlobalBannerFormat @ squareup/messageservice/service.proto at 1093:1
 */
export const GlobalBannerFormat = $root.lookupType('squareup.messageservice.service.GlobalBannerFormat');
fixType(GlobalBannerFormat, {
  type: {
    required: true
  },
  body: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GlobalBannerFormat);
/**
 * SOURCE GlobalBannerType @ squareup/messageservice/service.proto at 1130:3
 */
GlobalBannerFormat.GlobalBannerType = $root.lookupEnum('squareup.messageservice.service.GlobalBannerFormat.GlobalBannerType').values;
/**
 * SOURCE GlobalBannerCtaType @ squareup/messageservice/service.proto at 1138:3
 */
GlobalBannerFormat.GlobalBannerCtaType = $root.lookupEnum('squareup.messageservice.service.GlobalBannerFormat.GlobalBannerCtaType').values;
/**
 * SOURCE BannerV2Format @ squareup/messageservice/service.proto at 1146:1
 */
export const BannerV2Format = $root.lookupType('squareup.messageservice.service.BannerV2Format');
fixType(BannerV2Format, {
  type: {
    required: true
  },
  title: {
    notEmpty: true
  },
  body: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BannerV2Format);
/**
 * SOURCE BannerV2Type @ squareup/messageservice/service.proto at 1177:3
 */
BannerV2Format.BannerV2Type = $root.lookupEnum('squareup.messageservice.service.BannerV2Format.BannerV2Type').values;
/**
 * SOURCE ReleaseTileFormat @ squareup/messageservice/service.proto at 1186:1
 */
export const ReleaseTileFormat = $root.lookupType('squareup.messageservice.service.ReleaseTileFormat');
fixType(ReleaseTileFormat, {
  title: {
    notEmpty: true
  },
  description: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ReleaseTileFormat);
/**
 * SOURCE ReleaseTileCtaType @ squareup/messageservice/service.proto at 1217:3
 */
ReleaseTileFormat.ReleaseTileCtaType = $root.lookupEnum('squareup.messageservice.service.ReleaseTileFormat.ReleaseTileCtaType').values;
/**
 * SOURCE CardFeedPostCategory @ squareup/messageservice/service.proto at 1223:1
 */
export const CardFeedPostCategory = $root.lookupEnum('squareup.messageservice.service.CardFeedPostCategory').values;
/**
 * SOURCE CardFeedPostContentNodeType @ squareup/messageservice/service.proto at 1230:1
 */
export const CardFeedPostContentNodeType = $root.lookupEnum('squareup.messageservice.service.CardFeedPostContentNodeType').values;
/**
 * SOURCE CardFeedPostContentHeadingFields @ squareup/messageservice/service.proto at 1237:1
 */
export const CardFeedPostContentHeadingFields = $root.lookupType('squareup.messageservice.service.CardFeedPostContentHeadingFields');
fixType(CardFeedPostContentHeadingFields);
Builder.createAndAttachToType(CardFeedPostContentHeadingFields);
/**
 * SOURCE CardFeedPostContentParagraphFields @ squareup/messageservice/service.proto at 1241:1
 */
export const CardFeedPostContentParagraphFields = $root.lookupType('squareup.messageservice.service.CardFeedPostContentParagraphFields');
fixType(CardFeedPostContentParagraphFields);
Builder.createAndAttachToType(CardFeedPostContentParagraphFields);
/**
 * SOURCE CardFeedPostContentImageFields @ squareup/messageservice/service.proto at 1245:1
 */
export const CardFeedPostContentImageFields = $root.lookupType('squareup.messageservice.service.CardFeedPostContentImageFields');
fixType(CardFeedPostContentImageFields);
Builder.createAndAttachToType(CardFeedPostContentImageFields);
/**
 * SOURCE CardFeedPostContentButtonFields @ squareup/messageservice/service.proto at 1252:1
 */
export const CardFeedPostContentButtonFields = $root.lookupType('squareup.messageservice.service.CardFeedPostContentButtonFields');
fixType(CardFeedPostContentButtonFields);
Builder.createAndAttachToType(CardFeedPostContentButtonFields);
/**
 * SOURCE CardFeedPostContentNode @ squareup/messageservice/service.proto at 1257:1
 */
export const CardFeedPostContentNode = $root.lookupType('squareup.messageservice.service.CardFeedPostContentNode');
fixType(CardFeedPostContentNode);
Builder.createAndAttachToType(CardFeedPostContentNode);
/**
 * SOURCE CardFeedPostFormat @ squareup/messageservice/service.proto at 1267:1
 */
export const CardFeedPostFormat = $root.lookupType('squareup.messageservice.service.CardFeedPostFormat');
fixType(CardFeedPostFormat);
Builder.createAndAttachToType(CardFeedPostFormat);
/**
 * SOURCE MessageTemplate @ squareup/messageservice/service.proto at 1278:1
 */
export const MessageTemplate = $root.lookupType('squareup.messageservice.service.MessageTemplate');
fixType(MessageTemplate);
Builder.createAndAttachToType(MessageTemplate);
/**
 * SOURCE GetMessageTemplateRequest @ squareup/messageservice/service.proto at 1299:1
 */
export const GetMessageTemplateRequest = $root.lookupType('squareup.messageservice.service.GetMessageTemplateRequest');
fixType(GetMessageTemplateRequest, {
  messageTemplateId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetMessageTemplateRequest);
/**
 * SOURCE GetMessageTemplateResponse @ squareup/messageservice/service.proto at 1303:1
 */
export const GetMessageTemplateResponse = $root.lookupType('squareup.messageservice.service.GetMessageTemplateResponse');
fixType(GetMessageTemplateResponse, {
  template: {
    required: true
  }
});
Builder.createAndAttachToType(GetMessageTemplateResponse);
/**
 * SOURCE UploadImageRequest @ squareup/messageservice/service.proto at 1307:1
 */
export const UploadImageRequest = $root.lookupType('squareup.messageservice.service.UploadImageRequest');
fixType(UploadImageRequest, {
  filename: {
    notEmpty: true
  },
  contentType: {
    notEmpty: true
  },
  image: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UploadImageRequest);
/**
 * SOURCE UploadImageResponse @ squareup/messageservice/service.proto at 1313:1
 */
export const UploadImageResponse = $root.lookupType('squareup.messageservice.service.UploadImageResponse');
fixType(UploadImageResponse, {
  url: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UploadImageResponse);
/**
 * SOURCE MessageserviceService @ squareup/messageservice/service.proto at 1317:1
 */
export const MessageserviceService = $root.lookupService('squareup.messageservice.service.MessageserviceService');